import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
// @ts-ignore
import {createBrowserHistory} from 'history';
import {createRouterMiddleware} from '@lagunovsky/redux-react-router';
import {createEpicMiddleware} from 'redux-observable';
import {rootReducer} from './root-reducer';
import {RootAction, RootState, Services} from './root-types';
import {spirsApi} from '../spirsApi';
import {rootEpic} from './root-epic';
import {StoreType} from "./spirs/types";

export const history = createBrowserHistory();
export const epicMiddleware = createEpicMiddleware<RootAction, RootAction, RootState, Services>({dependencies: spirsApi});

const routerMiddleWare = createRouterMiddleware(history);
const middlewares = [routerMiddleWare, epicMiddleware];
const enhancer = composeWithDevTools(applyMiddleware(...middlewares));
const initialState = {} as StoreType;

export const store = createStore(rootReducer(), initialState, enhancer);
epicMiddleware.run(rootEpic);
